import { SpeciesTaxonomyScreen } from '@/screens/SpeciesSearch/SpeciesTaxonomyScreen/SpeciesTaxonomyScreen';

export default function ReportCreationSpeciesTaxonomyScreen(): React.ReactNode {
  return <SpeciesTaxonomyScreen />;
}
